import * as variables from './variables.js';

import * as $ from 'jquery';
import './lib/AnimationEasing';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance({
    mirrorEvents: {
        microsoft: true     // Mirror events reported to GA to Microsoft's analytics (used for MS Ads)
	}
});

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import Gallery from './component/Gallery';
new Gallery();

// Feature Carousel //
import featureCarousel from './component/featureCarousel';
const entryCarouselEl = document.querySelector('.__entry .featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 6000
		// doIndicatorClick: true
	});
}

// Promotions
$('.promoItem__print').on('click', function(e) {
	e.preventDefault();
	e.stopPropagation();
	window.print();
});
$('.promoItem__container').on('click', function(e) {
	e.preventDefault();
	e.stopPropagation();
	togglePromo($(this));
});
$('.promoItem__fullLink').on('click', function(e) {
	e.preventDefault();
	e.stopPropagation();
	togglePromo($(this).parent().parent());
});
function togglePromo($promo: any) {
	if ($promo.hasClass('promoItem__container--print')) {
		// Close
		$promo.removeClass('promoItem__container--print');
		// $(document.documentElement).removeClass('isPromoItemOpenForPrinting');
	} else {
		// Open
		$promo.addClass('promoItem__container--print');
		// $(document.documentElement).addClass('isPromoItemOpenForPrinting');
	}
}